'use client'

import s from './News.module.scss';
import {Fragment, useEffect, useState} from "react";
import {TAllNewsItem} from "@/app/[locale]/news/types";
import {
    getStateFromLocalStorage
} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {
    extractTextNewsFromJSON
} from "@/app/[locale]/common/utils/functions/extractTextNewsFromJSON/extractTextNewsFromJSON";
import {getAllNews} from "@/app/[locale]/common/utils/functions/getAllNews/getAllNews";
import {ELEMENT_INDEX} from "@/app/[locale]/common/constants/app";
import {FIRST_NEWS, FOURTH_NEWS} from "@/app/[locale]/common/constants/main";
import {NewsCard} from '@/app/[locale]/common/components/News/NewsCard';
import {NewsMinorCard} from '@/app/[locale]/common/components/News/NewsMinorCard';
import {Line} from '@/app/[locale]/common/components/Line/Line';
import {Preloader} from "@/app/[locale]/common/components/Preloader/Preloader";
import {Empty} from "@/app/[locale]/common/components/Empty/Empty";

export const NewsBlock = () => {
    const [ data, setData ] = useState<TAllNewsItem[] | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            const storedNews = getStateFromLocalStorage('news');
            if (storedNews) {
                const news = extractTextNewsFromJSON(storedNews);
                setData(news);
                return;
            }
            await getAllNews(1, setData);
        };
        fetchData();
    }, []);

    if (!data) {
        return <Preloader />;
    }

    const featuredNews = data[ELEMENT_INDEX.FIRST];
    const minorNews = data.slice(FIRST_NEWS, FOURTH_NEWS);

    if (!featuredNews) {
        return <Empty />;
    }

    return (
        <div className={s.news_content}>
            <div className={s.news_content_mainCard}>
                <NewsCard
                    id={featuredNews.id}
                    title={featuredNews.title}
                    text={featuredNews.text}
                    date={featuredNews.date}
                    image={featuredNews.img}
                />
            </div>
            <div className={s.news_content_minor}>
                {minorNews.map((item: TAllNewsItem, index: number) => (
                    <Fragment key={item.id}>
                        <NewsMinorCard
                            id={item.id}
                            title={item.title}
                            text={item.text}
                            date={item.date}
                            image={item.img}
                        />
                        {index <= ELEMENT_INDEX.SECOND && <Line className={s.news_content_line} />}
                    </Fragment>
                ))}
            </div>
        </div>
    );
};
